import type { InternalPermission } from 'src/constants/internal-access/internalPermissions'
import { hasAnyPermission } from 'src/utils/internalAccess/hasAnyPermission'
import { useInternalPermissions } from './useInternalPermissions'

/** Pass a module-level constant array — see `useHasPermission` for the single-permission case. */
export const useHasAnyPermission = (required: InternalPermission[] | undefined): boolean => {
  const permissions = useInternalPermissions()

  return hasAnyPermission(permissions, required)
}
